/**
 * AUTO-GENERATED — DO NOT EDIT BY HAND
 *  Run `pnpm run gen-version` to refresh.
 */
export const STAGEHAND_VERSION = "3.2.1" as const;
